var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2066 2.21778L17.7782 3.49567C18.2057 3.84325 18.2811 4.48348 17.9467 4.92567L16.9668 6.22133L17.5851 6.72407L21.1841 7.28026C21.7297 7.36459 22.1022 7.91917 21.975 8.45762C21.2278 11.6189 19.2299 14.2606 16.4473 15.7669C15.9733 16.0234 15.3651 15.7805 15.156 15.2512L13.7769 11.7596L13.1586 11.2569L5.3283 21.6109C4.99389 22.0531 4.37627 22.1298 3.94881 21.7822L2.37723 20.5043C1.94977 20.1568 1.87434 19.5165 2.20875 19.0743L10.0391 8.72031L9.04668 7.92007C8.61922 7.57249 8.54379 6.93226 8.8782 6.49007L11.4754 3.05582C11.8098 2.61363 12.4274 2.53694 12.8549 2.88451L13.8473 3.68476L14.8272 2.38909C15.1616 1.9469 15.7792 1.8702 16.2066 2.21778Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxe);
export default __webpack_public_path__ + "static/media/axe.e277ce5137a67a8d56afbee877a56ff5.svg";
export { ForwardRef as ReactComponent };